const state = {
  errorMessage: '',
  visible: false
};

const mutations = {
  setError(state, message) {
    state.errorMessage = message;
    state.visible = true;
  },
  clearError(state) {
    state.errorMessage = '';
    state.visible = false;
  }
};

const actions = {
  raiseError({ commit }, message) {
    console.log('Store error:', message);
    commit('setError', message);
  },
  clearError({ commit }) {
    commit('clearError');
  }
};

const getters = {
  errorMessage: state => state.errorMessage,
  visible: state => state.visible
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};